import React from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon, MessageCircleIcon, StarIcon, ShieldCheckIcon } from 'lucide-react';
const guaranteePerks = [{
  icon: WrenchIcon,
  title: 'We optimize it for you',
  desc: 'Our team customizes the dashboard categories, formulas, and layout to match your specific business setup.',
  accent: '#00C9B1',
  num: '1'
}, {
  icon: MessageCircleIcon,
  title: 'Tell us more about your business',
  desc: 'Email us within 30 days. Describe your business type and what is not clicking for you. We listen.',
  accent: '#FFB800',
  num: '2'
}, {
  icon: StarIcon,
  title: 'Your custom version',
  desc: 'You get a version of the Command Center built around how your business actually works.',
  accent: '#b4a0ff',
  num: '3'
}];
export function GuaranteeSection() {
  return <section className="bg-[#0D1A35] py-24 relative overflow-hidden" data-id="element-119">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-teal/5 rounded-full blur-[120px] pointer-events-none" data-id="element-120" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-122">
          {/* Shield icon */}
          <div className="flex justify-center mb-6" data-id="element-123">
            <div className="w-20 h-20 rounded-2xl flex items-center justify-center" style={{
            background: 'linear-gradient(135deg, rgba(0,201,177,0.15), rgba(0,132,168,0.15))',
            border: '1px solid rgba(0,201,177,0.3)',
            boxShadow: '0 0 40px rgba(0,201,177,0.15)'
          }} data-id="element-124">
              <ShieldCheckIcon className="w-10 h-10 text-teal" data-id="element-125" />
            </div>
          </div>

          {/* Headline */}
          <div className="text-center mb-4" data-id="element-126">
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-teal bg-teal/10 border border-teal/20 px-4 py-1.5 rounded-full mb-5" data-id="element-127">
              30-Day Satisfaction Promise
            </span>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-white mb-4" data-id="element-128">
              Doesn't Work for You?
              <br data-id="element-129" />
              <span className="text-gradient-teal" data-id="element-130">We'll Build You a Custom Version.</span>
            </h2>
            <p className="text-white/55 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-131">
              We are so confident this will change how you run your business that if it does not fit within 30 days, we will personally optimize the dashboard to match your exact setup. For free.
            </p>
          </div>

          {/* 3-step process */}
          <div className="grid md:grid-cols-3 gap-6 mt-12 mb-10 relative" data-id="element-132">
            {/* Connecting line */}
            <div className="hidden md:block absolute top-8 left-[22%] right-[22%] h-px" style={{
            background: 'linear-gradient(90deg, transparent, rgba(0,201,177,0.3), rgba(255,184,0,0.3), transparent)'
          }} data-id="element-133" />

            {guaranteePerks.map((perk, i) => <motion.div key={perk.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.15,
            duration: 0.5
          }} className="text-center relative z-10" data-id="element-134">
                {/* Step number + icon */}
                <div className="relative inline-flex mb-5" data-id="element-135">
                  <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{
                background: `${perk.accent}18`,
                border: `1px solid ${perk.accent}35`,
                boxShadow: `0 0 20px ${perk.accent}15`
              }} data-id="element-136">
                    <perk.icon className="w-7 h-7" style={{
                  color: perk.accent
                }} data-id="element-137" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-extrabold text-white" style={{
                background: perk.accent
              }} data-id="element-138">
                    {perk.num}
                  </div>
                </div>
                <h4 className="font-display font-bold text-white text-base mb-2" data-id="element-139">{perk.title}</h4>
                <p className="text-white/45 text-sm leading-relaxed" data-id="element-140">{perk.desc}</p>
              </motion.div>)}
          </div>

          {/* Bottom statement */}
          <div className="text-center py-6 px-8 rounded-2xl" style={{
          background: 'rgba(0,201,177,0.06)',
          border: '1px solid rgba(0,201,177,0.15)'
        }} data-id="element-141">
            <p className="text-white/70 text-base leading-relaxed max-w-xl mx-auto" data-id="element-142">
              <span className="text-white font-semibold" data-id="element-143">No risk. No forms. No fine print.</span>{' '}
              Email us at{' '}
              <span className="text-teal font-medium" data-id="element-144">arktectsolutions@gmail.com</span>{' '}
              within 30 days and we handle the rest personally.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}